export const getEnv = varName => {
  const envVars = JSON.parse(sessionStorage.getItem('env'));

  if (!!envVars?.[varName]) return envVars[varName];

  return !!window.Cypress ? window.Cypress.env(varName) : process.env[varName];
};
